import Icon from '@/components/icons/Icon';
import { classnames } from '@/helpers';
import { twMerge } from 'tailwind-merge';
import Header, { HeaderProps } from '../../Header/Header';

type AccordionSize = 'lg' | 'md' | 'sm';

type AccordionProps = {
  size?: AccordionSize;
  className?: string;
  labelClassName?: string;
  expanded?: boolean;
} & Omit<HeaderProps, 'size'>;

const Accordion = ({
  size = 'lg',
  expanded,
  label,
  className = '',
  labelClassName = '',
  ...headerProps
}: AccordionProps) => {
  return (
    <div className={twMerge(classnames('pt-sm space-y-sm flex flex-col ', className))}>
      <div className="gap-md flex justify-between">
        {label && (
          <Header
            size={size}
            label={label}
            rightIcon={<Icon variant={expanded ? 'chevron-s-up' : 'chevron-s-down'} />}
            className={labelClassName}
            {...headerProps}
          />
        )}
      </div>
    </div>
  );
};

export default Accordion;
